/** * 安心付签约支付、支付 */
<template>
  <div class="menu-content">
    <vix-suspend-menu
      v-if="drawerVisible"
      ref="paydelayContainer"
      :show="drawerVisible"
      class="suspend-container"
      :class="[className]"
    >
      <div class="base-wrapper container">
        <info-toast v-if="toastShow"></info-toast>
        <transition name="slide-left">
          <div v-show="getHalfPageSwitchEmun === VisiblePage.index">
            <slot name="homePage"></slot>
          </div>
        </transition>
        <transition name="slide-right">
          <keep-alive>
            <agreement
              v-if="getHalfPageSwitchEmun === VisiblePage.agreement"
              :agreement-info="agreementInfo"
              :click-index="clickIndex"
              @toggleVisiblePage="setHalfPageSwitchEmun(VisiblePage.index)"
            />
          </keep-alive>
        </transition>
        <transition name="slide-right">
          <keep-alive>
            <order
              v-if="getHalfPageSwitchEmun === VisiblePage.order"
              :link="orderLink"
              title="请选择扣款顺序"
              @toggleVisiblePage="setHalfPageSwitchEmun(VisiblePage.index)"
            />
          </keep-alive>
        </transition>
        <transition name="slide-right">
          <keep-alive>
            <promo-info
              v-if="getHalfPageSwitchEmun === VisiblePage.promo"
              @toggleVisiblePage="setHalfPageSwitchEmun(VisiblePage.index)"
            />
          </keep-alive>
        </transition>
        <transition name="slide-right">
          <keep-alive>
            <instructionPage
              v-if="getHalfPageSwitchEmun === VisiblePage.instruction"
              :instruction-list="openPageData.instructionList"
              @toggleVisiblePage="setHalfPageSwitchEmun(VisiblePage.index)"
            />
          </keep-alive>
        </transition>
      </div>
    </vix-suspend-menu>
    <info-toast v-if="!drawerVisible && toastShow"></info-toast>
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import { VisiblePage } from '@/common';
import InfoToast from '@/views/components/InfoToast.vue';

export default Vue.extend({
  name: 'App',
  components: {
    InfoToast,
    Agreement: () => import(/* webpackChunkName: 'agreement' */ './Agreement.vue'),
    Order: () => import(/* webpackChunkName: 'order' */ '../order/Index.vue'),
    PromoInfo: () => import(/* webpackChunkName: 'promoInfo' */ './promo-info.vue'),
    InstructionPage: () => import(/* webpackChunkName: 'instructionPage' */ './instruction-page.vue'),
  },
  props: {
    drawerVisible: {
      type: Boolean,
      default: false,
    },
    openPageData: {
      type: Object,
      default: {} as ShowDataType,
    },
    className: {
      type: String,
      default: '',
    },
    isSetBackgroundColor: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      clickIndex: 0, // 点击的第几个协议
      orderLink: '', // 扣款顺序设置页地址
      VisiblePage,
    };
  },
  computed: {
    toastShow(): boolean {
      return this.$store.state.paydelaycashier.toastData.show;
    },
    getHalfPageSwitchEmun(): VisiblePage {
      return this.$store.state.paydelaycashier.halfPageSwitchEmun;
    },
    agreementInfo(): AgreementType[] {
      return this.openPageData.agreementInfo || [];
    },
  },
  watch: {
    isSetBackgroundColor() {
      this.$nextTick(() => {
        if (this.$refs.paydelayContainer && '$el' in this.$refs.paydelayContainer) {
          const paydelayContainerDom = this.$refs.paydelayContainer.$el;
          if (paydelayContainerDom) {
            (paydelayContainerDom as HTMLElement).style.backgroundColor = 'rgba(0,0,0,0.5)';
          }
        }
      });
    },
  },
  methods: {
    setHalfPageSwitchEmun(visiblePageEmun: VisiblePage) {
      this.$store.commit('paydelaycashier/setHalfPageSwitchEmun', { halfPageSwitchEmun: visiblePageEmun });
    },
  },
});
</script>
<style lang="less" scoped></style>
